export const MW_INTELLIGENCE_USER_NAME = 'Kate (Virtual Plaid)';

const LEGACY_MW_INTELLIGENCE_USER_NAME = 'MouseWait Intelligence';

const MW_INTELLIGENCE_ADMIN_USER_IDS = new Set(['18', '914', '38', '46770']);

export function isMouseWaitAdminLogin(
  userId = localStorage.getItem('user_id') || '',
  userName = localStorage.getItem('user_name') || ''
) {
  return (
    MW_INTELLIGENCE_ADMIN_USER_IDS.has(String(userId)) ||
    String(userName).trim().toLowerCase() === 'admin'
  );
}

export function isMouseWaitIntelligenceUser(user: any) {
  const userName = String(user?.user_name || '').trim().toLowerCase();

  return (
    userName === MW_INTELLIGENCE_USER_NAME.toLowerCase() ||
    userName === LEGACY_MW_INTELLIGENCE_USER_NAME.toLowerCase()
  );
}

export function canManageMouseWaitIntelligencePost(user: any) {
  return isMouseWaitAdminLogin() && isMouseWaitIntelligenceUser(user);
}
